/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import i18n from "./i18n/i18n";
import axios from "./axios.js";
import io from "socket.io-client";
import VueSocketIOExt from "vue-socket.io-extended";
import VueGtag from "vue-gtag";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import VeeValidate from "vee-validate";
import { VueHammer } from "vue2-hammer";
import { TreeViewPlugin, ContextMenuPlugin } from "@syncfusion/ej2-vue-navigations";
import VueApexCharts from "vue-apexcharts";
import VueVideoPlayer from "vue-video-player";
import VueTelInput from "vue-tel-input";
import VueDragResize from "vue-drag-resize";
import Vuesax from "vuesax";
import "vuesax/dist/vuesax.css";
import "material-icons/iconfont/material-icons.css";
import "video.js/dist/video-js.css";
import "vue-tel-input/dist/vue-tel-input.css";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import "vue-select/dist/vue-select.css";
import "@/assets/css/main.css";
import "@/assets/custom_fonts/custom_fonts.scss";
import "./assets/scss/main.scss";
import "./assets/css/iconfont.css";
import "./http/requests";
import "./globalComponents.js";
import "./filters/filters";
import "../themeConfig.js";
import CustomPaging from "./components/custom/CustomPaging";
import { millisecondsToMinutes } from "./functions/globalUtiles";
import { PUBLIC_PATHS, REG_PATHS, } from "./constants";
require("./assets/css/iconfont.css");

if (GA_CODE) {
  Vue.use(VueGtag, { config: { id: GA_CODE } }, router);
}
const socket = io(`${process.env.VUE_APP_SOCKET_PORT}/`, { withCredentials: false, query: { token: localStorage.token } });
Vue.use(Vuesax);
Vue.use(VueSocketIOExt, socket);
Vue.config.productionTip = false;
Vue.use(VueVideoPlayer);
Vue.use(VueDragResize);
Vue.component("VueDragResize", VueDragResize);
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);
Vue.use(VueTelInput, { validCharactersOnly: true, mode: "international" });
Vue.component("CustomPaging", CustomPaging);

Vue.prototype.$http = axios;
Vue.prototype.$moment = VueMoment;
Vue.use(VueMoment, {
  moment,
});
Vue.use(VeeValidate, { fieldsBagName: "formFields" });
Vue.use(VueHammer);
Vue.use(TreeViewPlugin);
Vue.use(ContextMenuPlugin);
const GA_CODE = process.env.VUE_APP_GA_CODE || null;

axios.interceptors.response.use(
  function (response) {
    if (response.data && response.data._sync_info) {
      store.commit("SET_SYNCH_NOTIFICATIONS", null);
      if (!response.data._sync_info.later) {
        setTimeout(() => {
          store.commit("SET_OPEN_POPUP_NOTIFICATION", {
            ...response.data._sync_info,
            isShow: true,
            countdown: millisecondsToMinutes(response.data._sync_info.avg_operation_time),
          });
        }, 200)

      } else {
        setTimeout(() => {
          store.commit("SET_SYNCH_NOTIFICATIONS", { ...response.data._sync_info, status: "PENDING" });
        }, 200)

      }
    }
    return response;
  },
  function (error) {
    if (error && error.response) {
      if (error.response.config.url == "cardholderGroup") {
        vm.$vs.notify({
          time: 7000,
          color: "danger",
          title: error.response.data.message,
        });
      } else if (error.response.status == 401) {
        if (error.response.data.message === "Wrong username or e-mail") {
          vm.$vs.notify({
            time: 7000,
            color: "danger",
            title: error.response.data.message,
          });
        } else if (localStorage.token) {
          vm.$vs.notify({
            time: 7000,
            color: "danger",
            title: error.response.data.message,
          });
          localStorage.clear();
          router
            .push("/login")
            .then((res) => { })
            .catch(() => { });
        }
      } else if (error.response.config.url.includes("camera/accessPoint")) {

      } else {
        if (error.response.data && error.response.data.message) {
          const message = error.response.data.message;
          if (message !== "There are no streams") {
            vm.$vs.notify({
              time: 7000,
              color: "danger",
              title: error.response.data.message,
            });
          }
        }
      }
      return Promise.reject(error);
    }
  }
);


const register_path = router.history._startLocation.split("/");
const urlParams = new URLSearchParams(window.location.search);
const token = urlParams.get('token');

function hasIsConnected() {
  const synch = JSON.parse(localStorage.getItem("synchStart"));
  if (synch) {
    return false
  }
  return sessionStorage.getItem('isConnected') !== null
}
if (
  localStorage.token &&
  router.history._startLocation !== "/login" &&
  register_path &&
  register_path.length && !REG_PATHS.includes(register_path[1])
) {

  axios
    .get(`account/getUserData`, {
      headers: { Authorization: localStorage.token },
    })
    .then((res) => {
      const settings_data = res.data.settings;
      if (res.data.support_obj && res.data.support_obj.enabled && !localStorage.getItem("showPopup")) {
        store.commit("SET_START_SUPPORTING", {
          ...res.data.support_obj
        })
      }
      const settings =
        settings_data && JSON.parse(settings_data)
          ? JSON.parse(settings_data)
          : {
            "theme_config": {
              "theme": "light"
            },
            "default": "true"
          };

      if (settings) {
        store.commit("SET_SETTINGS", settings);
        localStorage.setItem("settings", JSON.stringify(settings))
      }

      if ("theme" in settings.theme_config) {
        store.commit("UPDATE_THEME", settings.theme_config.theme);
        JSON.stringify(settings.theme_config)
      }

      localStorage.setItem("user", JSON.stringify(res.data));
      if (res.data.features) {
        localStorage.setItem("features", JSON.stringify(res.data.features));
      }
      axios
        .get(`${process.env.VUE_APP_BACK}/roles/${res.data.role}`, {
          headers: { Authorization: localStorage.token },
        })
        .then((result) => {
          localStorage.setItem("permissions", result.data.permissions);
        });

      // if (!hasIsConnected()) {
      if (!localStorage.getItem("showPopup")) {
        axios
          .get(`${process.env.VUE_APP_BACK}/sync`, {
            headers: { Authorization: localStorage.token }
          })
          .then((response) => {

            if (response.data.id) {
              store.commit("SET_SYNCH_NOTIFICATIONS", response.data);
            }
          })
          .catch((error) => {
          });
      }
    }
    )
    .catch((error) => {
      if (error.response && error.response.status == 401) {
        localStorage.clear();
        router.push("/login").catch(() => {
        });
      }
    });
} else {
  router.push("/login").catch(() => {
    localStorage.clear();
  });
}

router.beforeEach((to, from, next) => {
  if (!localStorage.token && !token) {
    if (!PUBLIC_PATHS.includes(to.name)) {
      return next("/login");
    } else {
      return next();
    }
  } else {
    return next();
  }
});

let vm = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");